import { useEffect, useRef, useState } from 'react'
import {
    faEllipsisVertical,
    faClone,
    faTrash,
    faCancel,
    faShare,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    Button,
    Dropdown,
    Container,
    Table,
    Modal,
    Form,
    Tab,
} from "react-bootstrap"
import { faEdit } from "@fortawesome/free-regular-svg-icons"
import { Pagination } from "../../../CommonComponents/Pagination"
import Tooltip from "@mui/material/Tooltip"
import {
    formatDate,
    formatToINR,
    sharePdf,
} from "../../../Utils/helpers/commonhelper"
import { baseURL } from "../../../Utils/constants/constant"
import { AuthorizationCard } from "../../../CommonComponents/AuthorizationCard"
import DeleteModal from '../../DeleteModal'
import { useLocation } from 'react-router-dom'
import useLocalStorageState from 'use-local-storage-state'
import { DeleteRequest, GetRequest, PutRequest } from '../../../Utils/hooks/ApiHandler'
import { toast } from 'sonner'
import { SalesOrderDetailsOffcanvas } from '../SalesOrderDetailsOffcanvas'
import { ProgressCircle } from './ProgressCircle'
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'
import { TableWrapper } from '../../../CommonComponents/TableWrapper'
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'

export const SalesListing = ({
    isMyApproval,
    allSalesOrder,
    activeOffset,
    setActiveOffset,
    salesOrderData,
    fetchSalesOrder,
    heading,
    limit,
    setLimit,
    isLoading,
    columns,
    tempFilterData,
    initialSalesId,
}) => {
    const location = useLocation();
    const mode = location?.state?.mode || "edit";
    const from = location?.state?.from || ""
    const paramId = location?.state?.paramId


    // getting essentials for api fetching
    const { customer, setCustomer, headers, extras, navigate, customerId: customer_id, loginUserId, userType } = useGetEssentials()
    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission')
    // sales permission
    const salesGrant = PERMISSION.sales_order;

    // state for show detail page
    const [showSalesOrderDetails, setShowSalesOrderDetails] = useState(false)
    const [departmentToDelete, setDepartmentToDelete] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [loading, setLoading] = useState(false)

    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)

    const [openRow, setOpenRow] = useState(null)

    const dataToDisplay =
        !tempFilterData ? allSalesOrder : tempFilterData?.data;

    const hasDataToDisplay = dataToDisplay?.length > 0;

    // state for making sure the pagination position remains updated with respect to current page items
    const currPageItems = dataToDisplay?.length;

    const isFiltered = tempFilterData !== null && tempFilterData !== undefined;

    // Calculate total pages
    const pageCount = Math.ceil(salesOrderData?.total_count / limit) || 0
    const effectivePageCount = isFiltered
        ? Math.ceil((tempFilterData?.total_count || 0) / limit)
        : pageCount

    const totalItems = isFiltered
        ? (tempFilterData?.total_count || 0)
        : (salesOrderData?.total_count || 0);

    const displayStartItem = totalItems === 0
        ? 0
        : activeOffset * limit + 1;

    const displayEndItem = totalItems === 0
        ? 0
        : Math.min(activeOffset * limit + limit, totalItems);


    const [showModal, setShowModal] = useState(false)
    const [toCancelQuotation, setToCancelQuotation] = useState()
    const [rejectReason, setRejectReason] = useState("")
    const filterCategoriesDropRef = useRef(null)

    const [editData, setEditData] = useState(null)
    const [isEditOpen, setIsEditOpen] = useState(false)
    const [isClone, setIsClone] = useState(false)

    // custom hook for outside click handler
    useOutsideClickHandler({
        objRef: filterCategoriesDropRef,
        isDropdown: filterCategoriesDropdown,
        setDropdown: setFilterCategoriesDrop
    })

    // useEffect(() => {
    //     if (tempFilterData !== null) {
    //         setActiveOffset(0)
    //     }
    // }, [tempFilterData])

    useEffect(() => {
        if (from === "detailPage") {
            handleSalesOrderDetails(paramId);
            window.history.replaceState({}, document.title);
        }
    }, [mode, from])

    // Handle page change from react-paginate
    const handlePageChange = (selectedItem) => {
        setActiveOffset(selectedItem.selected)
    }
    // const handleEditClick = async (id) => {
    //     if (!id) return
    //     try {
    //         const res = await GetRequest(
    //             `/sales/fetchDetailsOfSpecificOrder/${id}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
    //             { headers },
    //             extras
    //         )
    //         if (res.status === "success") {
    //             const editDataToSet = res.data[0]
    //             setEditData(editDataToSet)
    //             setIsEditOpen(true)
    //             setIsClone(false)
    //             // setsalesOrderId(id)
    //         }
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    const handleConfirm = async () => {
        setLoading(true)
        try {
            const payload = {
                order_id: toCancelQuotation,
                customer_id: customer_id,
                canceletion_reason: rejectReason,
                user_login_id: customer?.customer_details?.id,
            }
            const res = await PutRequest(
                `sales/cancelSalesOrder`,
                payload,
                { headers },
                extras
            )

            if (!res || res.status === "fail") {
                return toast.error(res.message || "something went wrong")
            }
            if (res.status === "success") {
                toast.success(res.message)
                setToCancelQuotation()
                setRejectReason("")
                await fetchSalesOrder()
                setShowModal(false)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setShowModal(false)
            setLoading(false)
        }
    }

    const FilterdCols = columns.filter(c => c !== "Invoiced");
    const Columns = !isMyApproval ? columns : FilterdCols;

    const handleCloseModal = () => {
        setShowModal(false)
        setRejectReason("")
        setLoading(false)
    }

    const handleCancelSalesOrder = (saleOrder) => {
        if (!saleOrder) return

        setToCancelQuotation(saleOrder.sales_id)

        setShowModal(true)
    }

    // Trigger delete modal
    const onDelete = (id) => {
        setDepartmentToDelete(id)
        setShowDeleteModal(true)
    }

    const handleSalesOrderDetails = async (id) => {
        if (!id) return
        try {
            const res = await GetRequest(
                `/sales/fetchDetailsOfSpecificOrder/${id}/${customer_id}/${loginUserId}`,
                { headers },
                extras
            )
            if (res.status === "success") {
                const editDataToSet = res.data
                setEditData(editDataToSet[0])
                setShowSalesOrderDetails(true)

                setIsClone(false)
                // setsalesOrderId(id)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleShareSalesOrder = async (saleOrder) => {
        if (!saleOrder?.sales_id) {
            toast.error("Sales order not found!")
            return
        }

        const orderCustomerId =
            saleOrder?.customer_id || customer_id

        await sharePdf(
            `${baseURL}/sales/downloadSalesOrder/${orderCustomerId}/${saleOrder.sales_id}`,
            headers,
            "download",
            loginUserId,
            setLoading,
            `sales_order_${saleOrder.sale_no}`
        )
    }

    useEffect(() => {
        if (initialSalesId) {
            handleSalesOrderDetails(initialSalesId);
            navigate(location.pathname, { replace: true });
        }
    }, [initialSalesId]);

    const handleClose = () => {
        setShowSalesOrderDetails(false)
        navigate("/salesorder", { replace: true });
    }

    // const handleCloneClick = async (id) => {
    //     if (!id) return;
    //     try {
    //         const res = await GetRequest(
    //             `/sales/fetchDetailsOfSpecificOrder/${id}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
    //             { headers },
    //             extras
    //         );
    //         if (res.status === "success") {
    //             const cloneDataToSet = res.data[0];
    //             setEditData(cloneDataToSet);
    //             // setsalesOrderId(res.data[0].sales_id);
    //             setIsEditOpen(true);
    //             setIsClone(true);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    // Confirm delete and call API
    const handleConfirmedDelete = async () => {
        setLoading(true)
        try {
            const item = allSalesOrder.find((d) => d.sales_id === departmentToDelete)

            const res = await DeleteRequest(
                `sales/deleteSalesOrder/${departmentToDelete}/${loginUserId}`,
                { headers },
                extras
            )

            if (res?.status === "success") {
                toast.success(res.message)
                await fetchSalesOrder()
                setLoading(false)
            } else if (res.status === "fail") {
                toast.error(res.message)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Delete error:", error)
        } finally {
            setLoading(false)
            setShowDeleteModal(false)
            setDepartmentToDelete(null)
        }
    }

    const tableHeader = () => (<thead style={{ zIndex: 101 }}>
        <tr>
            <th
                className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
                style={{
                    width: 60,
                    minWidth: 60,
                    maxWidth: 60,
                    left: 0,
                }}
            >
                <span>#</span>
            </th>
            {
                Columns?.map((col, index) => (
                    <th key={`header-${index}`} style={{ textAlign: `${col?.toLowerCase() === "status" && "center"}` }}>{col}</th>
                ))
            }
            {isMyApproval ? (
                ""
            ) : (
                <th>
                    Action{" "}
                    <i
                        className="fa-solid fa-sort"
                        style={{ fontSize: "0.6rem" }}
                    ></i>
                </th>
            )}
        </tr>
    </thead>)

    const tableBody = () => ((
        dataToDisplay?.map((saleOrder, index) => (
            <tr key={saleOrder?.sales_id || index}>
                <td>{(activeOffset) * limit + (index + 1)}</td>

                {/* Dynamic cells based on columns order */}
                {columns?.map((col, cellIndex) => {
                    switch (col) {
                        case "Date":
                            return (
                                <td key={`cell-${index}-${cellIndex}`}>
                                    {formatDate(saleOrder.sales_order_date)}
                                </td>
                            );

                        case "Sales Order#":
                            return (
                                <td
                                    key={`cell-${index}-${cellIndex}`}
                                    style={{ color: "#0099ff", cursor: "pointer" }}
                                    data-bs-target="#saleOrderDetails"
                                    data-bs-toggle="offcanvas"
                                    onClick={() => handleSalesOrderDetails(saleOrder.sales_id)}
                                >
                                    {saleOrder.sale_no}{" "}
                                    <i className="fa-regular fa-envelope"></i>
                                </td>
                            );

                        case "Quotation Number":
                            return (
                                <td key={`cell-${index}-${cellIndex}`} className="sales-td">
                                    {saleOrder.quotation_number ?? "-"}
                                </td>
                            );

                        case "Customer Name":
                            return (
                                <td key={`cell-${index}-${cellIndex}`}>
                                    <Tooltip
                                        title={saleOrder.contact_full_name || "-"}
                                        arrow
                                        placement="top"
                                        disableHoverListener={
                                            !saleOrder.contact_full_name ||
                                            saleOrder.contact_full_name.length < 24
                                        }
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    fontSize: "0.7rem",
                                                    backgroundColor: "#7a3a5e",
                                                    color: "white",
                                                },
                                            },
                                            arrow: {
                                                sx: {
                                                    color: "#7a3a5e",
                                                },
                                            },
                                        }}
                                    >
                                        <span
                                            style={{
                                                display: "inline-block",
                                                maxWidth: "200px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                verticalAlign: "bottom",
                                            }}
                                        >
                                            {saleOrder.contact_full_name || "-"}
                                        </span>
                                    </Tooltip>
                                </td>
                            );

                        case "Status":
                            return (
                                <td
                                    key={`cell-${index}-${cellIndex}`}
                                    style={{
                                        textTransform: "capitalize",
                                        textAlign: "center",
                                    }}
                                >
                                    <span style={{
                                        textTransform: "capitalize",
                                        color:
                                            saleOrder.order_status === "pending"
                                                ? "#a28414"
                                                : saleOrder.order_status === "draft"
                                                    ? "#1f7a96"
                                                    : saleOrder.order_status === "cancel"
                                                        ? "#9e1920"
                                                        : saleOrder.order_status === "approved"
                                                            ? "#239b11"
                                                            : saleOrder.order_status === "reject"
                                                                ? "#4f575b"
                                                                : "#999",
                                        borderRadius: "12px",
                                        padding: "1.5px 6px",
                                        backgroundColor:
                                            saleOrder.order_status === "pending"
                                                ? "#f9f0ce"
                                                : saleOrder.order_status === "draft"
                                                    ? "#ceecf5"
                                                    : saleOrder.order_status === "cancel"
                                                        ? "#f8d3d5"
                                                        : saleOrder.order_status === "approved"
                                                            ? "#c0f7b8"
                                                            : saleOrder.order_status === "reject"
                                                                ? "#d2d6d8"
                                                                : "",
                                    }}>{saleOrder?.order_status?.toUpperCase() || "-"}</span>

                                </td>
                            );

                        case "Invoiced":
                            return !isMyApproval && (
                                <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                    <Tooltip
                                        title={`${saleOrder?.invoiced_percentage?.toFixed(0) || 0}% Completed`}
                                        arrow
                                        placement="right"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    fontSize: "0.7rem",
                                                    backgroundColor: "#7a3a5e",
                                                    color: "white",
                                                },
                                            },
                                            arrow: {
                                                sx: {
                                                    color: "#7a3a5e",
                                                },
                                            },
                                        }}
                                    >
                                        <div
                                            style={{
                                                cursor: "pointer",
                                                display: "inline-block",
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <ProgressCircle
                                                key={`${heading}-${saleOrder.sales_id}`}
                                                percentage={saleOrder.invoiced_percentage}
                                            />
                                        </div>
                                    </Tooltip>
                                </td>
                            );


                        case "Amount":
                            return (
                                <td key={`cell-${index}-${cellIndex}`} style={{ width: "3rem" }}>
                                    {formatToINR(
                                        JSON.parse(saleOrder?.items)?.[0]?.grand_total
                                    ) || 0}
                                </td>
                            );

                        case "Expected Shipment Date":
                            return (
                                <td key={`cell-${index}-${cellIndex}`} style={{ width: "3rem", textAlign: "center" }}>
                                    {formatDate(saleOrder?.shipment_date)}
                                </td>
                            );
                        // case "Order Status":
                        //   return (
                        //     <td key={`cell-${index}-${cellIndex}`}>
                        //       <img
                        //         src={delivered}
                        //         className="me-2"
                        //         alt=""
                        //         style={{ width: 15 }}
                        //       />
                        //       Delivered
                        //     </td>
                        //   );

                        // case "Delivery Method":
                        //   return (
                        //     <td key={`cell-${index}-${cellIndex}`}>
                        //       By Road
                        //     </td>
                        //   );

                        default:
                            return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                    }
                })}

                {/* Actions column */}
                {isMyApproval ? (
                    ""
                ) : (
                    <td
                        key={`actions-${index}`}
                        className={!isMyApproval ? "" : "lastactionTd"}
                        style={{
                            zIndex: openRow === saleOrder.sales_id ? 11 : "auto",
                            textAlign: "center"
                        }}
                    >
                        <div>
                            <Dropdown
                                as="div"
                                className="dropdownsWithoutToggle"
                                onToggle={(isOpen) =>
                                    setOpenRow(isOpen ? saleOrder.sales_id : null)
                                }
                            >
                                <Dropdown.Toggle
                                    as="button"
                                    type="button"
                                    style={{
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        margin: 0,
                                        cursor: "pointer",
                                        lineHeight: "1",
                                    }}
                                    className="three-dot-btn"
                                >
                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    align={"end"}
                                    style={{
                                        width: "7rem",
                                        inset: "0px auto auto 0px",
                                        boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                        position: "absolute",
                                        marginTop: "-22px",
                                        marginRight: "30px",
                                        minWidth: "3rem",
                                        zIndex: 1000,
                                    }}
                                >
                                    {saleOrder.order_status === "approved" ? (
                                        ""
                                    ) : (
                                        <>
                                            <Dropdown.Item
                                                href="#"
                                                className="d-flex align-items-center"
                                                onClick={() => {
                                                    if (!salesGrant?.isEdit) {
                                                        toast.warning("You are not authorized for this action!")
                                                        return
                                                    }
                                                    navigate(
                                                        `/editsalesorder/${saleOrder.sales_id}`,
                                                        {
                                                            state: { mode: "edit" },
                                                        }
                                                    )
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faEdit}
                                                    style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        marginRight: "9px",
                                                        color: "#5e5f60",
                                                    }}
                                                />
                                                Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="#"
                                                className="d-flex align-items-center"
                                                onClick={() => {
                                                    if (!salesGrant?.isCreate) {
                                                        toast.warning("You are not authorized for this action!")
                                                        return
                                                    }
                                                    navigate(
                                                        `/editsalesorder/${saleOrder.sales_id}`,
                                                        {
                                                            state: { mode: "clone" },
                                                        }
                                                    )
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faClone}
                                                    style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        marginRight: "9px",
                                                        color: "#5e5f60",
                                                    }}
                                                />
                                                Clone
                                            </Dropdown.Item>
                                        </>
                                    )}
                                    <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            if (!salesGrant?.isExport) {
                                                toast.warning("You are not authorized for this action!")
                                                return
                                            }
                                            handleShareSalesOrder(saleOrder)
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faShare}
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "9px",
                                                color: "#5e5f60",
                                            }}
                                        />
                                        Share
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={() => {
                                            if (!salesGrant?.isDelete) {
                                                toast.warning("You are not authorized for this action!")
                                                return
                                            }
                                            saleOrder.order_status === "approved"
                                                ? handleCancelSalesOrder(saleOrder)
                                                : onDelete(saleOrder.sales_id)
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                saleOrder.order_status === "approved"
                                                    ? faCancel
                                                    : faTrash
                                            }
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "9px",
                                                color: "#5e5f60",
                                            }}
                                        />
                                        {saleOrder.order_status === "approved"
                                            ? "Cancel"
                                            : "Delete"}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                )}
            </tr>
        ))
    ))
    return (
        <>
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmedDelete}
                isLoading={loading}
                message="Are you sure you want to delete this item?"
            />


            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 14rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px"
                    }}
                    className='position-relative container-table '
                >
                    <TableWrapper
                        isLoading={isLoading}
                        hasData={hasDataToDisplay}
                        tableHeader={tableHeader()}
                        tableBody={tableBody()}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        currPageItems={currPageItems}
                        offset={activeOffset}
                        setOffset={setActiveOffset}
                        limit={limit}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={effectivePageCount}
                        columnLabels={columns}
                    />

                </div>
                {showModal && (
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Cancel Sales Order</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <>
                                <p>Are you sure you want to cancel the sales order?</p>
                                <Form.Group controlId="rejectReason">
                                    <Form.Label>Reason</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={rejectReason}
                                        onChange={(e) => setRejectReason(e.target.value)}
                                    />
                                </Form.Group>
                            </>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-default-outline me-2"
                                onClick={handleCloseModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn-default"
                                onClick={handleConfirm}
                                disabled={rejectReason.trim() === ""}
                            >
                                {loading ? "submiting.." : "Confirm"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </Container>

            {showSalesOrderDetails && editData && (
                <SalesOrderDetailsOffcanvas
                    isMyApproval={isMyApproval}
                    isEditOpen={isEditOpen}
                    setIsEditOpen={setIsEditOpen}
                    isClone={isClone}
                    fetchSalesOrder={fetchSalesOrder}
                    show={showSalesOrderDetails}
                    setShowSalesOrderDetails={setShowSalesOrderDetails}
                    salesDetails={editData}
                    // handleCloneClick={handleCloneClick}
                    // handleEditClick={handleEditClick}
                    handleClose={handleClose}
                />
            )
            }
        </>
    )
}
